import * as firebase from "firebase/app";
import "firebase/analytics";
import firebaseConfig from "./firebase.config";

// https://firebase.google.com/docs/reference/js/firebase.analytics.Analytics.html

try {
    firebase.initializeApp(firebaseConfig);
} catch (e) {
    // Polyfill for IE missing
    console.debug(e);
}

var analytics = null;
var pendingUserId = null;
var pendingProperties = [];
var pendingEvents = [];

export function initialize() {
    try {
        analytics = firebase.analytics();
    } catch (e) {
        // not initialized due to Polyfill for IE missing
        console.debug(e);
    }
    if (pendingUserId !== null) {
        setUserId(pendingUserId);
    }
    pendingProperties.forEach(p => setUserProperties(p));
    pendingEvents.forEach(e => {
        const { eventName, eventParams } = e;
        logEvent(eventName, eventParams);
    });
}

export function setUserId(id) {
    if (analytics) {
        analytics.setUserId(id)
    } else {
        pendingUserId = id;
    }
}

export function setUserProperties(properties) {
    if (analytics) {
        analytics.setUserProperties(properties)
    } else {
        pendingProperties.push(properties);
    }
}

export function logEvent(eventName, eventParams) {
    if (analytics) {
        analytics.logEvent(eventName, eventParams)
    } else {
        pendingEvents.push({ eventName, eventParams });
    }
}

export function updateUserInterfaceStyle() {
    this.setUserProperties({
        "user_interface_style": window.matchMedia ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark" : "light") : "none"
    });
}

export function setPlusAccountUser(isCustomer) {
    this.setUserProperties({
        "is_pp_user": isCustomer
    });
}

export function logJqXHR(jqXHR) {
    var trackingHeader = jqXHR.getResponseHeader("X-Tracking-Event");
    if (trackingHeader) {
        var parts = trackingHeader.split(";", 2);
        var trackingEvent = parts[0];
        var params = parts[1];
        logEvent(trackingEvent, params ? JSON.parse(params) : undefined);
    }
}
